import { TFunction } from "i18next";
import { KeptTrainingRecord, MemberErasureResult } from "../models/MemberErasure";
import { formatDateOnly } from "../../training/utils/formatDateOnly";

/** Joins sentences the way the language does: Japanese runs them together, others with a space. */
export const joinSentences = (sentences: string[], language: string): string =>
  sentences.filter(Boolean).join(language.startsWith("ja") ? "" : " ");

/**
 * One sentence per training record an erasure keeps under legal hold (PD-0021), naming the
 * programme and the date, from the given translation key. Empty when nothing is kept.
 */
export const trainingHoldSentences = (
  t: TFunction,
  records: KeptTrainingRecord[],
  language: string,
  key: string
): string =>
  joinSentences(
    records.map((record) =>
      t(key, { programme: record.programmeName, date: formatDateOnly(record.heldUntil, language) })
    ),
    language
  );

/**
 * The toast after an erasure: one kept record names its date, several name only the law
 * (their dates differ), none is the plain "erased" message.
 */
export const erasureToastText = (t: TFunction, result: Omit<MemberErasureResult, "memberId">,
  language: string, plainKey: string): string => {
  if (result.heldEnrolments > 1) return t("members.dataRights.erasedWithHolds");
  if (result.heldEnrolments === 1 && result.heldUntil) {
    return t("members.dataRights.erasedWithHold", { date: formatDateOnly(result.heldUntil, language) });
  }
  return t(plainKey);
};
